<div class="container-fluid px-4 mt-4 mb-5">
<div class="cp-page-header mb-4">
    <div class="cp-page-title">
        <i class="fa-solid fa-file-lines me-2"></i>
        Registro de Actividades
    </div>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/">Sistema</a></li>
            <li class="breadcrumb-item active">Logs</li>
        </ol>
    </nav>
</div>

<div class="card">
    <div class="card-header cp-list-header">
        <span class="cp-list-title">Log de Actividades de Usuarios</span>
    </div>
    <div class="card-body">
        <!-- Filtros -->
        <div class="cp-filter-panel">
            <div class="cp-toolbar">
                <div style="flex: 0 1 170px;">
                    <label class="form-label">Desde</label>
                    <input type="date" class="form-control" [(ngModel)]="filters.from" (change)="applyFilters()" />
                </div>
                <div style="flex: 0 1 170px;">
                    <label class="form-label">Hasta</label>
                    <input type="date" class="form-control" [(ngModel)]="filters.to" (change)="applyFilters()" />
                </div>
                <div style="flex: 1 1 260px;">
                    <label class="form-label">Buscar</label>
                    <input type="search" class="form-control" [(ngModel)]="filters.q" maxlength="100" placeholder="Usuario, acción o descripción" (keyup.enter)="applyFilters()" />
                </div>
                <div style="flex: 0 0 auto;">
                    <button class="btn btn-primary me-2" type="button" (click)="applyFilters()"><i class="fa-solid fa-magnifying-glass me-1"></i> Filtrar</button>
                    <button class="btn btn-outline-secondary" type="button" (click)="clearFilters()" [disabled]="!hasFilters"><i class="fa-solid fa-rotate-left me-1"></i> Limpiar</button>
                </div>
            </div>
            <div class="text-danger small mt-2" *ngIf="filterError">{{ filterError }}</div>
        </div>

        <ngb-pagination [maxSize]="10" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
            (pageChange)="getData()"></ngb-pagination>
        <div class="table-responsive">
            <table class="table cp-table align-middle">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Acción</th>
                        <th>Detalle</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items">
                        <td class="small text-nowrap">{{ item.created_at | date: 'dd-MM-yyyy' }}<div class="text-muted">{{ item.created_at | date: 'HH:mm:ss' }}</div></td>
                        <td>
                            <div class="fw-bold">{{ item.user_name || item.username || '—' }}</div>
                            <div class="small text-muted" *ngIf="item.user_name && item.username && item.username !== item.user_name">{{ item.username }}</div>
                        </td>
                        <td>
                            <span class="badge" [ngClass]="verbClass(actionParts(item.action).verb)">{{ actionParts(item.action).verb }}</span>
                            <div class="small text-muted mt-1" *ngIf="actionParts(item.action).area">{{ actionParts(item.action).area }}</div>
                        </td>
                        <td class="small" style="min-width: 260px">
                            <span [innerHTML]="detail(item.obs)"></span>
                        </td>
                    </tr>
                    <tr *ngIf="items && items.length === 0">
                        <td colspan="4"><div class="cp-empty"><i class="fa-solid fa-file-lines"></i>No se encontraron registros{{ hasFilters ? ' con los filtros indicados' : '' }}.</div></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ngb-pagination [maxSize]="10" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
            (pageChange)="getData()"></ngb-pagination>
    </div>
</div>
</div>
